import React, { useState, useEffect } from "react";
import { ReactComponent as Cancel } from "../../../Assets/Image/svg/cancel.svg";
import { useForm } from "react-hook-form";
import { BtnPrimary } from "../../share/buttons/Btn";
import DatePickerInput from "../../share/input/DatePicker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import goast from "../../../Assets/Image/png/goast.png";
import useFetch from "../../../Hooks/useFetch";
import moment from "jalali-moment";

function AdminPriorityModal({
    close,
    bootcampId,
    getPriorityService,
    priority,
}) {
    const [start, setStart] = useState();
    const [end, setEnd] = useState();
    const [time, setTime] = useState({
        start: "",
        end: "",
    });

    const [step, setStep] = useState(0);
    const {
        register,
        handleSubmit,
        control,
        formState: { errors },
    } = useForm();

    const newPriority = useFetch({
        method: "POST",
        url: `BootCampIdeasPriorityService`,
        noHeader: false,
        trigger: false,
        setter: () => {
            setStep(1);
            getPriorityService.reFetch();
        },
        data: time,
    });
    const editPriority = useFetch({
        method: "PATCH",
        url: `BootCampIdeasPriorityService/${priority?.id}`,
        noHeader: false,
        trigger: false,
        setter: (data) => {
            setStep(1);
            getPriorityService.reFetch();
        },
        data: time,
    });

    useEffect(() => {
        if (!!priority) {
            setStart(() =>
                moment(priority.priority_start_time)
                    .locale("fa")
                    .format("HH:mm:ss YYYY/MM/DD ")
            );

            setEnd(() =>
                moment(priority.priority_end_time)
                    .locale("fa")
                    .format("HH:mm:ss YYYY/MM/DD")
            );
        }
    }, [priority]);

    const onSubmit = () => {
        const formData = new FormData();
        const startTime = moment
            .from(start, "fa", "HH:mm:ss YYYY/MM/DD")
            .locale("en")
            .format("YYYY-MM-DDTHH:mm:ss.sssZ");

        const endTime = moment
            .from(end, "fa", "HH:mm:ss YYYY/MM/DD")
            .locale("en")
            .format("YYYY-MM-DDTHH:mm:ss.sssZ");
        formData.append("priority_start_time", startTime);
        formData.append("priority_end_time", endTime);
        console.log("onSubmit ~ !!priority:", !priority);
        if (!priority) {
            setTime(formData);
            formData.append("bootcamp", bootcampId);
            newPriority.reFetch();
        } else {
            setTime(formData);
            formData.append("id", bootcampId);
            editPriority.reFetch();
        }
        setStart(() => "");
        setEnd(() => "");

        // if (!!priority?.id) {
        // 	formData.append('id', bootcampId);
        // 	// editPriority.reFetch();
        // } else {
        // }
    };

    return (
        <div className="AddnewsupportTicket relative">
            <button
                onClick={() => close(false)}
                className="AddnewsupportTicket-cancel absolute  "
            >
                <div>
                    <Cancel />
                </div>
            </button>
            {step === 0 ? (
                <>
                    <h3 className=" text-center text-[#77498F] text-[16px] mb-16">
                        اطلاعات زمانی اولویت دهی
                    </h3>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className=" mb-[2rem]">
                            <DatePickerInput
                                register={{
                                    required: true,
                                }}
                                defaultValue={start}
                                setDate={setStart}
                                message="زمان شروع اولویت دهی*"
                                placeholder="زمان شروع اولویت دهی*"
                                full={true}
                                name="catch_start_date"
                                control={control}
                                format="HH:mm:ss YYYY/MM/DD "
                                plugins={[<TimePicker position="bottom" />]}
                            />
                        </div>
                        <DatePickerInput
                            register={{
                                required: true,
                            }}
                            defaultValue={end}
                            setDate={setEnd}
                            message="زمان پایان اولویت دهی*"
                            placeholder="زمان پایان اولویت دهی*"
                            full={true}
                            name="catch_end_date"
                            control={control}
                            format="HH:mm:ss YYYY/MM/DD "
                            plugins={[<TimePicker position="bottom" />]}
                        />
                        <div className=" text-left mt-[3rem]">
                            <BtnPrimary
                                className="py-[20px] px-[25px] "
                                text="ثبت زمان"
                                type={"submit"}
                                htmlType="submit"
                            />
                        </div>
                    </form>
                </>
            ) : (
                <div>
                    <img
                        src={goast}
                        alt="goast"
                        className=" max-w-[11.582rem] max-h-[9.465rem] text-center mx-auto"
                    />
                    <p className=" mt-[1.7rem] text-[#212121E5] font-medium text-[2.4rem] leading-[4.8rem] text-center mx-auto">
                        اولویت دهی فعال شد!
                    </p>
                    <p className=" text-[#212121E5] font-normal text-[1.8rem] leading-[3.2rem] text-center mx-auto mt-[0.8rem]">
                        افراد بوت کمپ میتوانند از بخش ثبت اولویت، اولویت های خود
                        را ثبت کنند.
                    </p>
                    <div className=" text-center mt-[3rem]">
                        <BtnPrimary
                            className="py-[20px] px-[25px] "
                            text="متوجه شدم"
                            onClick={() => {
                                close(false);
                                setStep(0);
                            }}
                        />
                    </div>
                </div>
            )}
        </div>
    );
}

export default AdminPriorityModal;
